import axios from 'axios';
import { ORDENES_DEVOLUCION } from './types';

import { setAlert } from './alert';
import { changeLoader } from './loader';

export const buscarInventarioEntregado = (id_proyecto) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    };

    const body = JSON.stringify({ id_proyecto });

    try {
        await dispatch({ type: ORDENES_DEVOLUCION.INVENTARIO_ENTREGADO_CARGANDO });
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/ordenes_devolucion/inventario_entregado`, body, config);

        await dispatch({
            type: ORDENES_DEVOLUCION.INVENTARIO_ENTREGADO,
            payload: {
                productos: res.data?.productos || [],
                paquetes: res.data?.paquetes || []
            }
        });

        await dispatch(changeLoader(false));
        return true;
    } catch (error) {
        await dispatch(changeLoader(false));
        await dispatch({ type: ORDENES_DEVOLUCION.ERROR });
        dispatch(setAlert(error?.response?.data?.msg || 'Error al consultar el inventario entregado', 'danger'));
        return false;
    }
};

export const limpiarInventarioEntregado = () => dispatch => {
    dispatch({ type: ORDENES_DEVOLUCION.LIMPIAR_INVENTARIO_ENTREGADO });
};

export const listarOrdenes = (filtros = {}) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    };

    const body = JSON.stringify({
        id_proyecto: filtros.id_proyecto ?? null,
        status: filtros.status ?? null
    });

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/ordenes_devolucion/listar`, body, config);

        await dispatch({
            type: ORDENES_DEVOLUCION.LISTAR,
            payload: res.data?.ordenes || []
        });

        await dispatch(changeLoader(false));
        return true;
    } catch (error) {
        await dispatch(changeLoader(false));
        await dispatch({ type: ORDENES_DEVOLUCION.ERROR });
        dispatch(setAlert(error?.response?.data?.msg || 'Error al listar órdenes de devolución', 'danger'));
        return false;
    }
};

export const filtrarOrdenes = (texto = '') => dispatch => {
    dispatch({
        type: ORDENES_DEVOLUCION.FILTRAR,
        payload: texto
    });
};

export const limpiarOrdenes = () => dispatch => {
    dispatch({ type: ORDENES_DEVOLUCION.LIMPIAR });
};

export const obtenerOrden = (id) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    };

    const body = JSON.stringify({ id });

    try {
        await dispatch({ type: ORDENES_DEVOLUCION.DETALLE_CARGANDO });
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/ordenes_devolucion/detalles`, body, config);

        await dispatch({
            type: ORDENES_DEVOLUCION.DETALLE,
            payload: res.data?.orden || null
        });

        await dispatch(changeLoader(false));
        return res.data?.orden || null;
    } catch (error) {
        await dispatch(changeLoader(false));
        await dispatch({ type: ORDENES_DEVOLUCION.ERROR });
        dispatch(setAlert(error?.response?.data?.msg || 'Error al consultar la orden de devolución', 'danger'));
        return null;
    }
};

export const limpiarDetalleOrden = () => dispatch => {
    dispatch({ type: ORDENES_DEVOLUCION.LIMPIAR_DETALLE });
};

export const crearOrden = (data = {}) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    };

    const body = JSON.stringify({
        id_proyecto: data.id_proyecto || '',
        fecha: data.fecha || null,
        observaciones: data.observaciones || null,
        productos: Array.isArray(data.productos) ? data.productos : [],
        paquetes: Array.isArray(data.paquetes) ? data.paquetes : []
    });

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/ordenes_devolucion/crear`, body, config);

        await dispatch(changeLoader(false));

        if (!res.data?.success) {
            dispatch(setAlert(res.data?.msg || 'No se pudo crear la orden de devolución', 'danger'));
            return null;
        }

        dispatch(setAlert(res.data?.msg || 'Orden de devolución creada correctamente', 'success'));

        return res.data?.orden || null;
    } catch (error) {
        await dispatch(changeLoader(false));
        await dispatch({ type: ORDENES_DEVOLUCION.ERROR });
        dispatch(setAlert(error?.response?.data?.msg || 'Error al crear la orden de devolución', 'danger'));
        return null;
    }
};

export const editarOrden = (data = {}) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    };

    const body = JSON.stringify({
        id: data.id || '',
        fecha: data.fecha || null,
        observaciones: data.observaciones || null,
        productos: Array.isArray(data.productos) ? data.productos : [],
        paquetes: Array.isArray(data.paquetes) ? data.paquetes : []
    });

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/ordenes_devolucion/editar`, body, config);

        await dispatch(changeLoader(false));

        if (!res.data?.success) {
            dispatch(setAlert(res.data?.msg || 'No se pudo editar la orden de devolución', 'danger'));
            return null;
        }

        dispatch(setAlert(res.data?.msg || 'Orden de devolución editada correctamente', 'success'));

        return res.data?.orden || null;
    } catch (error) {
        await dispatch(changeLoader(false));
        await dispatch({ type: ORDENES_DEVOLUCION.ERROR });
        dispatch(setAlert(error?.response?.data?.msg || 'Error al editar la orden de devolución', 'danger'));
        return null;
    }
};

export const cambiarStatusOrden = (id, status, productos = null) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    };

    const body = JSON.stringify({
        id,
        status,
        productos: Array.isArray(productos) ? productos : undefined
    });

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/ordenes_devolucion/editar_status`, body, config);

        await dispatch(changeLoader(false));

        if (!res.data?.success) {
            dispatch(setAlert(res.data?.msg || 'No se pudo actualizar el status de la orden', 'danger'));
            return false;
        }

        dispatch(setAlert(res.data?.msg || 'Status de la orden actualizado correctamente', 'success'));

        return true;
    } catch (error) {
        await dispatch(changeLoader(false));
        await dispatch({ type: ORDENES_DEVOLUCION.ERROR });
        dispatch(setAlert(error?.response?.data?.msg || 'Error al actualizar el status de la orden', 'danger'));
        return false;
    }
};

export const devolverOrdenCompleta = (data = {}) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    };

    const body = JSON.stringify({
        id_orden_salida: data.id_orden_salida || '',
        fecha: data.fecha || null,
        observaciones: data.observaciones || null
    });

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/ordenes_devolucion/devolucion_completa`, body, config);

        await dispatch(changeLoader(false));

        if (!res.data?.success) {
            dispatch(setAlert(res.data?.msg || 'No se pudo registrar la devolución completa', 'danger'));
            return false;
        }

        dispatch(setAlert(res.data?.msg || 'Devolución completa registrada correctamente', 'success'));

        return true;
    } catch (error) {
        await dispatch(changeLoader(false));
        await dispatch({ type: ORDENES_DEVOLUCION.ERROR });
        dispatch(setAlert(error?.response?.data?.msg || 'Error al registrar la devolución completa', 'danger'));
        return false;
    }
};

export const eliminarOrden = (id, id_proyecto) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    };

    const body = JSON.stringify({ id });

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/ordenes_devolucion/eliminar`, body, config);

        await dispatch(changeLoader(false));

        if (!res.data?.success) {
            dispatch(setAlert(res.data?.msg || 'No se pudo eliminar la orden de devolución', 'danger'));
            return false;
        }

        dispatch(setAlert(res.data?.msg || 'Orden de devolución eliminada correctamente', 'success'));

        await dispatch(listarOrdenes({ id_proyecto }));

        return true;
    } catch (error) {
        await dispatch(changeLoader(false));
        await dispatch({ type: ORDENES_DEVOLUCION.ERROR });
        dispatch(setAlert(error?.response?.data?.msg || 'Error al eliminar la orden de devolución', 'danger'));
        return false;
    }
};
